type Option = {
  label: string;
};

export function useSortedOptions<O extends Option>(options: readonly O[] | undefined, sort: boolean) {
  const opts = options ?? [];
  const sortedOptions = sort
    ? [...opts].sort((a, b) => (a.label === 'None' ? -1 : b.label === 'None' ? 1 : a.label.localeCompare(b.label)))
    : opts;

  return sortedOptions;
}
